import React from 'react';
import styles from './Pagination.module.css'; // Add relevant CSS for styling.

const Pagination = ({ limit, totalPages, page, hasPrevPage, hasNextPage, onPageChange }) => {
    return (
        <div className={styles.paginationContainer}>
            <button
                className={`${styles.pageButton} ${!hasPrevPage ? styles.disabled : ''}`}
                onClick={() => hasPrevPage && onPageChange(page - 1)}
                disabled={!hasPrevPage}
            >
                Previous
            </button>
            <div className={styles.pageInfo}>
                Page {page} of {totalPages}
            </div>
            <button
                className={`${styles.pageButton} ${!hasNextPage ? styles.disabled : ''}`}
                onClick={() => hasNextPage && onPageChange(page + 1)}
                disabled={!hasNextPage}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;
